/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import CountUpNumbers from './Classes/CountUpNumbers';
import Link from './Classes/Link';
import Progressbar from './Classes/Progressbar';
import TeaserHeight from './Classes/TeaserHeight';
import Header from "./Classes/Header";

import Tabs from './Classes/Tabs';
import ScrollToContent from './Classes/ScrollToContent';
import ScrollToTop from './Classes/ScrollToTop';
import HeroVideo from './Classes/HeroVideo';

import Video from './Classes/Video';
import SliderHandler from './Classes/SliderHandler';
import SearchForm from './Classes/SearchForm';

import Accordion from './Classes/Accordion';
import AccordionCol from './Classes/AccordionCol';
import FrontpageTabs from './Classes/FrontpageTabs';
import CVToggle from './Classes/CVToggle';
import Gri from './Classes/Gri';
import RelevanceMatrix from './Classes/RelevanceMatrix';
import StrategySvg from './Classes/StrategySvg';
import Popup from './Classes/Popup';
import InteractiveStory from './Classes/InteractiveStory';
import CVTextSameHeight from './Classes/CVTextSameHeight';
import swiper from './lib/swiper';
import ReplaceTriangle from "./Classes/ReplaceTriangle";


var linkInstance = null;
var teaserInstance = null;
var headerInstance = null;
var searchFormInstance = null;


var accordionInstance = null;
var accordioncolInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var videoInstance = null;
var youtubeVideoInstance = null;

var countUpInstance = null;
var progressbarInstance = null;

var tabInstance = null;
var heroInstance = null;

var toContentInstance = null;
var toTopInstance = null;

var sliderInstance = null;
var swiperInstance = null;

var cvToggleInstance = null;
var cvTextSameHeightInstance = null;

var gri = null;

var relevanceMatrixInstance = null;
var strategySvgInstance = null;
var popupInstance = null;

var interactiveStoryInstance = null;
var replaceTriangleInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};

// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  videoInstance = new Video();


  //force load swiper images
  Helper.loadImagesInContainer('.ns-slider-milestones');
  Helper.loadImagesInContainer('.lc-slider-highlights');
  Helper.loadImagesInContainer('.ns-slider');


  //initialize img slider
  sliderInstance = new SliderHandler({
    outerWrapperSelector: '.ns-slider'
  });

  //initialize frontpage slider "milestones slider"
  swiperInstance = new swiper('.ns-slider-milestones > .swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    wrapperClass: 'swiper-wrapper',
    initialSlide: 0,
    loop: true,
    loopedSlides: 20,
    navigation: {
      nextEl: ".ns-slider-frontpage__next",
      prevEl: ".ns-slider-frontpage__prev",
    },

    breakpoints: {
      512: {
        initialSlide: 0,
        spaceBetween: 41,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        initialSlide: 0,
        spaceBetween: 41,
        slidesPerView: 1,
        centeredSlides: true,
      }
    },
  });

  document.querySelectorAll('.ns-slider-milestones__prev').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slidePrev();
    })
  });

  document.querySelectorAll('.ns-slider-milestones__next').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slideNext();
    })
  });

  //initialize frontpage slider "highlights slider"
  swiperInstance = new swiper('.lc-slider-highlights > .swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    wrapperClass: 'swiper-wrapper',
    initialSlide: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    pagination: {
			el: ".lc-slider-highlights__pagination",
			type: "bullets",
			clickable: true,
		},
    loopedSlides: 20,
    navigation: {
      nextEl: ".lc-slider-highlights__next",
      prevEl: ".lc-slider-highlights__prev",
    },

    breakpoints: {
      512: {
        initialSlide: 0,
        spaceBetween: 30,
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        initialSlide: 0,
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: true,
      }
    },
  });

  document.querySelectorAll('.lc-slider-highlights__prev').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slidePrev();
    })
  });

  document.querySelectorAll('.lc-slider-highlights__next').forEach(p => {
    p.addEventListener('click', (e) => {
      swiperInstance.slideNext();
    })
  });

  var lang = document.documentElement.lang;
  if ( lang == "en" || lang == "en-US") {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.', // default: '.'
        numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
        thousandsSep: '\u002C', // default: '\u0020'
        shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      }
    });
  } else {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.', // default: '.'
        numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
        thousandsSep: '\u0027', // default: '\u0020'
        shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      }
    });
  }

  linkInstance = new Link({
    linksSelector: '.js-open-in-new-tab'
  });

  headerInstance = new Header({
    submenuSelector: '.menu__wrap--level-1',
    submenuTogglerSelector: '.menu__item--has-children .menu__link--level-0',
    submenuL1Selector: '.menu__wrap--level-2',
    submenuL1TogglerSelector: '.menu__item--has-children > .menu__link--level-1',
    menuTogglerSelector: '.js-menu-toggle',
    menuContainerMobileSelector: '.header__bottom',
    menuContainerSelector: '.header__navigation',
    searchTogglerSelector: '.js-search-toggle',
    searchContainerSelector: '.header__search',
    searchFormInput: '.form__input--search',
    languageTogglerSelector: '.js-language-toggle',
    languageContainerSelector: '.header__language',
    headerSelector: '.header',
    headerPolyfillSelector: '.header-polyfill',
    scrollDistance: 260,
    metaTogglerSelector: '.js-meta-options',
    metaContainerSelector: '.header__meta-group--desktop'
  });

  new FrontpageTabs();

  heroInstance = new HeroVideo({
    heroSelector: ".ns-hero-section:not(.ns-hero-section--bg)"
  });

  //tabInstance = new Tabs();

  teaserInstance = new TeaserHeight();

  accordionInstance = new Accordion({
    accordions: '.category .js-toggle-accordion'
  });

  accordioncolInstance = new AccordionCol({
    accordionToggles: '.ns-accordion-col .js-toggle-accordion'
  });
  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  countUpInstance = new CountUpNumbers({
      numbersSelector: '.ns-keyfigure__number',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: ['de-DE', 'en-US', 'fr-FR'],
      decimalArray: ['.', '.', '.'],
      thousandSepArray: ['’', ',', '’'],
  });

  progressbarInstance = new Progressbar({
    progressbars: '.ns-progress-bar'
  });

  toContentInstance = new ScrollToContent({
    buttonSelector: '.js-tocontent-toggle'
  });

  toTopInstance = new ScrollToTop({
    buttonSelector: '.js-backtotop-toggle'
  });

  searchFormInstance = new SearchForm({
    searchFormInput: '.search-results__form .form__input--search'
  });

  cvToggleInstance = new CVToggle({});

  gri = new Gri();

  relevanceMatrixInstance = new RelevanceMatrix({
    idName: 'toggle',
    className: 'popup--'
  });

  strategySvgInstance = new StrategySvg({
    idName: 'toggle',
    className: 'popup--'
  });

  popupInstance = new Popup({
    buttons: '.scroll-image__button',
    closebtn: '.close-btn',
    backdrops: '.popup__backdrop'
  });

  interactiveStoryInstance = new InteractiveStory({
    triggerSelector: '.ns-interactive-story__icon',
    contentSelector: '.ns-interactive-story__content'
  });

  cvTextSameHeightInstance = new CVTextSameHeight({
    cvSelector: '.ns-cv'
  });
});
